import { render, staticRenderFns } from "./SetOffData.vue?vue&type=template&id=57454b88&"
import script from "./SetOffData.vue?vue&type=script&lang=js&"
export * from "./SetOffData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports